import { j as t } from "./jsx-runtime-944c88e2.js";
import { B as o } from "./ButtonGroup-a9850ef0.js";
import "react";
import "./index-efd35e77.js";
import "./package-metadata-9ad1330d.js";
import "./index-64063129.js";
const s = (r) => /* @__PURE__ */ t.jsx(o, { ...r, children: r.children });
export {
  s as ButtonGroup
};
